import { IPhlebotRequest, IListItem, IBaseResponse } from '@nkr/models/index';
import { ViewWrapper } from './styles';
import ViewPhlebotRequestContent from './view-phlebot-request-content';

interface IProps {
    isAdminView: boolean,
    data: IPhlebotRequest,
    types: IListItem[],
    states: IListItem[],
    onUpdate: (request: IPhlebotRequest) => void,
    onReorderRequest: (requestId: number) => void,
    onUpdateRquestInViewToSent: (requestId: number) => void,
    onUpdateRequestToSentStatus: (requestId: number) => Promise<IBaseResponse>
}

const ViewPhlebotRequest = (props: IProps) => {
    return (
        <ViewWrapper>
            <div className='modal-container'>
                <ViewPhlebotRequestContent
                    isAdminView={props.isAdminView}
                    data={props.data}
                    types={props.types}
                    states={props.states}
                    onUpdate={props.onUpdate}
                    onUpdateRequestInViewToSent={props.onUpdateRquestInViewToSent}
                    onUpdateRequestToSentStatus={props.onUpdateRequestToSentStatus}
                    onReorderRequest={props.onReorderRequest}
                />
            </div>
        </ViewWrapper>
    );
}

export default ViewPhlebotRequest;